import { Seo } from '../components/Seo';
import { Hero } from '../components/sections/Hero';
import { BannerCarousel } from '../BannerCarousel';
import { BrandIntro } from '../components/sections/BrandIntro';
import { FeaturedProducts } from '../components/sections/FeaturedProducts';
import { CategoryShowcase } from '../components/sections/CategoryShowcase';
import { CropFinder } from '../components/sections/CropFinder';
import { WhyGreenbay } from '../components/sections/WhyGreenbay';
import { ApplicationJourney } from '../components/sections/ApplicationJourney';
import { GalleryPreview } from '../components/sections/GalleryPreview';
import { AboutPreview } from '../components/sections/AboutPreview';
import { ContactCta } from '../components/sections/ContactCta';
import { AppDownload } from '../components/sections/AppDownload';
import { WaveDivider } from '../components/common/WaveDivider';
import { company } from '../data/company';
import { organizationSchema, websiteSchema, localBusinessSchema } from '../lib/seo';

export default function HomePage() {
  return (
    <>
      <Seo
        title="GreenbayBio — Bio-Fertilizers & Biostimulants for Indian Farmers"
        description={company.description}
        path="/"
        keywords={[
          'bio fertilizer company in India',
          'biostimulant products India',
          'soil biology products',
          'Greenbay Biotech International',
        ]}
        jsonLd={[organizationSchema(), websiteSchema(), localBusinessSchema()]}
      />
      {/* Default = the premium art-directed Hero. An admin can override it from /admin/banners with a
          custom banner (single image + focal point = fully responsive, no per-device images). */}
      <BannerCarousel fallback={<Hero />} />
      <BrandIntro />
      <FeaturedProducts />
      <CategoryShowcase />
      <CropFinder />
      <WhyGreenbay />
      <ApplicationJourney />
      <WaveDivider fill="#F7F5EF" variant="wave" className="-mt-px bg-night text-canvas" />
      <GalleryPreview />
      <AboutPreview />
      <ContactCta />
      <AppDownload />
    </>
  );
}
